module.exports = __webpack_public_path__ + "static/img/jbpt.52a29eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/components/img/jbpt.jpg
// module id = Rv4G
// module chunks = 1